export default __webpack_public_path__ + "static/media/1986.c423ff0a.png";